import { CommonModule, CurrencyPipe, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieModule } from 'ngx-cookie';
import { RateCyberService } from '../rate/rate-cyber.service';
import { AppComponent } from './app.component';
import { AppRouting } from './app.routing';
import { TarifrechnerCommonModule } from '@vhv/tarifrechner-common';
import { CyberZusammenfassungComponent } from '../views/antrag/cyber-zusammenfassung.component';
import { CyberHeaderComponent } from '../component/cyber-header.component';
import { CyberBetriebsartComponent } from '../views/betriebsart/cyber-betriebsart.component';
import { CyberBausteineComponent } from '../views/cyber-bausteine/cyber-bausteine.component';
import {
    CyberSicherheitsvorkehrungenComponent
} from '../views/sicherheitsvorkehrungen/cyber-sicherheitsvorkehrungen.component';
import { CyberBeitragComponent } from '../views/beitrag/cyber-beitrag.component';
import { DownloadCyberService } from '../service/download-cyber.service';
import { CyberAnfrageDankeComponent } from '../views/antrag/cyber-anfrage-danke.component';
import { CyberErrorComponent } from '../views/error/cyber-error.component';
import { CyberDankeComponent } from '../views/antrag/cyber-danke.component';
import { CyberModalAreaComponent } from '../component/modal-area/cyber-modal-area.component';
import { PostErrorHandler } from './post-error-handler';

registerLocaleData(localeDe, 'de', localeDeExtra);

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AppRouting,
        BrowserAnimationsModule,
        CookieModule.withOptions(),
        TarifrechnerCommonModule,
    ],
    declarations: [
        AppComponent,
        CyberHeaderComponent,
        CyberBeitragComponent,
        CyberZusammenfassungComponent,
        CyberBetriebsartComponent,
        CyberBausteineComponent,
        CyberSicherheitsvorkehrungenComponent,
        CyberAnfrageDankeComponent,
        CyberErrorComponent,
        CyberDankeComponent,
        CyberModalAreaComponent

    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'de-DE'},
        RateCyberService,
        CurrencyPipe,
        DownloadCyberService,
        {provide: ErrorHandler, useClass: PostErrorHandler}
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}


